import { FC } from 'react';
import { RenderFilters } from '../../../Components/Custom/RenderFilters';
import { RenderSorting } from '../../../Components/Custom/RenderSorting';
import {
  INPUT_TYPE_AMOUNT,
  INPUT_TYPE_DATE_RANGE,
  INPUT_TYPE_SEARCH,
  INPUT_TYPE_SELECT
} from '../../../helpers/helpers';

interface FiltersProps {
  params: URLSearchParams;
  setParams: any;
}

export const Filters: FC<FiltersProps> = ({ params, setParams }) => {
  const statusOptions = [
    { label: 'Pending', value: '1' },
    { label: 'Paid', value: '2' },
    { label: 'Completed', value: '3' },
    { label: 'Canceled', value: '4' },
    { label: 'Automatic payout in progress', value: '5' },
    { label: 'Automatic payout paid', value: '6' }
  ];

  const sortOrderOptions = [
    { label: 'Ascending', value: 'ASC' },
    { label: 'Descending', value: 'DESC' }
  ];

  const sortByOptions = [
    { label: 'Date Created', value: 'dateCreated' },
    { label: 'Status', value: 'status' }
  ];

  const sortingInputs = [
    { param: 'sortBy', type: INPUT_TYPE_SELECT, options: sortByOptions },
    { param: 'sortOrder', type: INPUT_TYPE_SELECT, options: sortOrderOptions }
  ];

  const filterInputs = [
    { param: 'userId', type: INPUT_TYPE_SEARCH, placeholder: 'Search User ID' },
    {
      param: 'userWithdrawalId',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search User Withdrawal ID'
    },
    {
      param: 'address',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search address'
    },

    { param: '', type: INPUT_TYPE_DATE_RANGE },
    {
      param: 'status',
      type: INPUT_TYPE_SELECT,
      placeholder: 'Status',
      options: statusOptions
    },
    {
      param: 'fromAmount',
      type: INPUT_TYPE_AMOUNT,
      placeholder: 'From amount'
    },
    { param: 'toAmount', type: INPUT_TYPE_AMOUNT, placeholder: 'To Amount' }
  ];

  return (
    <>
      <RenderSorting
        sortingInputs={sortingInputs}
        searchParams={params}
        setSearchParams={setParams}
      />
      <RenderFilters
        filterInputs={filterInputs}
        searchParams={params}
        setSearchParams={setParams}
      />
    </>
  );
};
